import { render, staticRenderFns } from "./VipMemberCenter.vue?vue&type=template&id=59727065&scoped=true&"
import script from "./VipMemberCenter.vue?vue&type=script&lang=js&"
export * from "./VipMemberCenter.vue?vue&type=script&lang=js&"
import style0 from "./VipMemberCenter.vue?vue&type=style&index=0&id=59727065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59727065",
  null
  
)

export default component.exports